import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Chip, } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import Link from '@mui/material/Link';
import { OpenSwal, GoogleMapNavigation, notistackSnakebar } from '../../Utils';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';
import { saveAs } from 'file-saver';
import Stack from '@mui/material/Stack';
import DownloadIcon from '@mui/icons-material/Download';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { Divider } from '@mui/material';
// import LanguageIcon from '@mui/icons-material/Language';
import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';
import '../../SvgIcons/ImageIcons.css';
import { useSnackbar } from 'notistack';
import dayjs from 'dayjs';
import { url_get_voucher_html, url_cancel_assignment, url_change_assignment_status } from '../../RoutesMap';
import { apiWithAuth } from '../../Services/Axios/axios';

export default function AssignmentAfterAcceptComp({ AssignmentDetailsAry, AssignmentDetailsAryAllSet, changeAssignStatus, changeAssignPostStatus, AssignmentCustomerPromtAfterAcceptAry, AssignmentCustomerPromtAfterAcceptConsumerServName, AssignmentStartdateTimeSet, AssignmentCancelReasonsArySet, assign_id, DialogBoxStatusSet }) {
    const [StartButtonLoading, StartButtonLoadingSet] = useState(false);
    const [ArrivedButtonLoading, ArrivedButtonLoadingSet] = useState(false);
    const [GetStartButtonLoading, GetStartButtonLoadingSet] = useState(false);
    const [CancelButtonLoading, CancelButtonLoadingSet] = useState(false);
    const [StartButtonStatus, StartButtonStatusSet] = useState('');
    const [startArrivedDisabled, startArrivedDisabledSet] = useState(false);
    const [startButtoncancelDisable, startButtoncancelDisableSet] = useState(false);
    const [DownloadVoucherLoadingButton, DownloadVoucherLoadingButtonSet] = useState(false);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
    const AssignmentStartAction = (btn_status) => {
        if (btn_status === "Started") {
            StartButtonLoadingSet(true);
            AxiosAssignmentStartAction('', '', btn_status);
        }
        else if (btn_status === "Arrived") {
            if (!navigator.geolocation) {
                notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: "Geolocation is Not Supported in your browser", variant: 'error' });
            } else {
                ArrivedButtonLoadingSet(true);
                navigator.geolocation.getCurrentPosition(function (position) {
                    AxiosAssignmentStartAction(position.coords.latitude, position.coords.longitude, btn_status);
                }, function (error) {
                    // ArrivedButtonLoadingSet(false);
                    // if (error.code === 1) {
                    //     notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: "Please turn on the location Permission", variant: 'error' });
                    // } else {
                    //     notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: error.message, variant: 'error' });
                    // }
                    AxiosAssignmentStartAction('', '', btn_status);
                });
            }

        }
        else if (btn_status === "Check In") {
            GetStartButtonLoadingSet(true);
            AxiosAssignmentStartAction('', '', btn_status);
        }
        else if (btn_status === "Cancelled") {
            const assignmentDate = dayjs(AssignmentDetailsAry.assign_requestdatetime, "MM/DD/YYYY hh:mm A");
            const now = dayjs();
            const diffHours = assignmentDate.diff(now, "hour");
            if (diffHours < 24) {
                Swal.fire({
                    title: "Withdraw from Assignment",
                    text: "To withdraw from assignments with less than 24 hours notice, please call our coordination team at 860-647-0686.",
                    icon: "warning",
                    confirmButtonText: "Okay",
                    confirmButtonColor: "#89B601",
                    color: appThemeColor,
                    showCancelButton: false
                });
            } else {
                Swal.fire({
                    title: 'Withdraw from Assignment',
                    text: "Do you wish to withdraw from assignment number " + AssignmentDetailsAry.assign_orderid + "?",
                    icon: 'error',
                    showCancelButton: true,
                    confirmButtonText: "Confirm",
                    cancelButtonColor: '#f44336',
                    confirmButtonColor: '#89B601',
                    cancelButtonText: "Cancel",
                    color: appThemeColor
                }).then((result) => {
                    if (result.isConfirmed) {
                        CancelButtonLoadingSet(true);
                        AxiosAssignmentCancelAction();
                    }
                });
            }
        }
    }

    const AxiosAssignmentStartAction = (latitude, longitude, btn_status) => {
        let Apply_local_time_statelocalstorage = localStorage.getItem('Apply_local_time_state');
        let payload_data = { latitude: latitude, longitude: longitude, assignid: assign_id, status: btn_status, localtime: Apply_local_time_statelocalstorage }
        apiWithAuth.post(url_change_assignment_status, payload_data, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
            if (response.data.status) {
                if (btn_status === "Started") {
                    Swal.fire({
                        title: "On Your Way!",
                        text: response.data.message,
                        showCancelButton: true,
                        cancelButtonColor: '#89B601',
                        cancelButtonText: '<i class="icon-park-outline--map-distance"></i>Start Navigation',
                        confirmButtonText: 'Ok',
                        icon: "success",
                        confirmButtonColor: "#89B601",
                        color: appThemeColor,
                        // reverseButtons: true,
                        focusConfirm: false,
                        backdrop: true,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then((result) => {
                        if (result.isConfirmed) {

                        } else {
                            asyncCall();
                        }
                        StartButtonStatusSet('Arrived');
                        changeAssignPostStatus('Started');
                    });
                } else {
                    let title_text = "";
                    let confirm_btn_text = "Ok";
                    if (btn_status === "Arrived") {
                        title_text = "Destination Reached!";
                    } else if (btn_status === "Check In") {
                        title_text = "Let's Get Started!";
                        confirm_btn_text = "Begin Assignment";
                    }
                    Swal.fire({
                        title: title_text,
                        icon: "success",
                        text: response.data.message,
                        color: appThemeColor,
                        confirmButtonText: confirm_btn_text,
                        confirmButtonColor: "#89B601",
                    }).then((result) => {
                        if (btn_status === "Arrived") {
                            StartButtonStatusSet('Arrived');
                            startArrivedDisabledSet(true);
                            ArrivedButtonLoadingSet(false);
                        }
                        AssignmentDetailsAryAllSet({ ...AssignmentDetailsAry, assign_post_status: btn_status });
                        changeAssignPostStatus(btn_status);
                    });
                }


                AssignmentStartdateTimeSet(response.data.current_date_time);
            } else if (response.data.status === false && response.data.message === "Token Expired") OpenSwal('Token_error', navigate);
            else {
                StartButtonLoadingSet(false);
                ArrivedButtonLoadingSet(false);
                GetStartButtonLoadingSet(false);
                CancelButtonLoadingSet(false);
                OpenSwal('Axios_error', response.data.message);
            }

        }).catch(response => OpenSwal('Axios_error', response.message));
    }
    async function asyncCall() {
        if (!navigator.geolocation) {
            OpenSwal('Axios_error', 'Geolocation is Not Supported in your browser');
        } else {
            navigator.geolocation.getCurrentPosition(async function (position) {
                GoogleMapNavigation({ latitude: position.coords.latitude, longitude: position.coords.longitude, address: AssignmentDetailsAry.assign_location });
            }, function (error) {
                if (error.code === 1) {
                    OpenSwal('Axios_error', error.message + '. Please turn on the location Permission.');
                } else OpenSwal('Axios_error', error.message);
            });
        }
    }

    const AxiosAssignmentCancelAction = () => {

        let payload_data = { assignid: assign_id, }
        apiWithAuth.post(url_cancel_assignment, payload_data, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
            if (response.data.status) {
                CancelButtonLoadingSet(false);
                startButtoncancelDisableSet(true);
                changeAssignStatus('CancelStart');
                AssignmentCancelReasonsArySet(response.data.cancellation_reasons);
            } else if (response.data.status === false && response.data.message === "Token Expired") OpenSwal('Token_error', navigate);
            else {
                CancelButtonLoadingSet(false);
                startButtoncancelDisableSet(false);
                OpenSwal('Axios_error', response.data.message);
            }
        }).catch(response => {
            startButtoncancelDisableSet(false);
            CancelButtonLoadingSet(false);
            OpenSwal('Axios_error', response.message)
        });
    }

    useEffect(() => {
        if (AssignmentDetailsAry.assign_post_status === '') StartButtonStatusSet('Start');
        else if (AssignmentDetailsAry.assign_post_status === 'Started') StartButtonStatusSet('Arrived');
        else if (AssignmentDetailsAry.assign_post_status === 'Arrived') {
            startArrivedDisabledSet(true);
            StartButtonStatusSet('Arrived');
        }
    }, [])


    const AssignmentDownloadVoucherHtml = (assign_id) => {


        DownloadVoucherLoadingButtonSet(true);

        let payload_data = { assignid: assign_id }

        apiWithAuth.post(url_get_voucher_html, payload_data, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
            if (response.data.status) {
                DownloadVoucherLoadingButtonSet(false);
                saveAs(response.data.file_blob, response.data.file_name);
            } else if (response.data.status === false && response.data.message === "Token Expired") {
                DownloadVoucherLoadingButtonSet(false);
                OpenSwal('Token_error', navigate);
            } else {
                DownloadVoucherLoadingButtonSet(false);
                OpenSwal('Axios_error', response.data.message);
            }
        }).catch(response => {
            DownloadVoucherLoadingButtonSet(false);
            OpenSwal('Axios_error', response.message);
        });


    }

    return (
        <Box>
            <Box sx={{ mt: 2, ml: 1 }}>
                <Stack direction="row" spacing={1}>
                    <Typography variant="h6" sx={{ padding:"20px 0px 0px 0px" }} fontWeight="bold" color={appThemeColor}>  {AssignmentDetailsAry.assign_industry} </Typography>
                    {/* {AssignmentDetailsAry.assign_applicant_counts === 1 && <Chip label='QR Code' size="small" onClick={() => DialogBoxStatusSet(true)} sx={{ backgroundColor: '#89B601', color: '#fff', borderRadius: 2, cursor: 'pointer', '&:hover': { backgroundColor: '#6f9401' } }} />} */}
                </Stack>
                <Typography variant="h6" fontWeight="bold" color={appThemeColor} sx={{ mt: -1 }}  > {AssignmentDetailsAry.assign_client_name} </Typography>
                <Box sx={{ display: 'flex' }}>
                    <TranslateOutlinedIcon sx={{ color: appThemeColor, fontSize: '16px', mt: '2px', mr: 0.2 }} /> <Typography variant="subtitle2" color={appThemeColor} > {AssignmentDetailsAry.language_name} | {AssignmentDetailsAry.service_type_short} </Typography>
                </Box>



                <Box sx={{ mt: 1 }}>
                <Grid container>
    <Grid xs={6} sm={4} md={3}>
        <Typography
            variant='body2'
            fontWeight='bold'
            sx={{ letterSpacing: '-0.2px', whiteSpace: 'nowrap' }}
        >
            Reports To
        </Typography>
    </Grid>

    <Grid xs={6} sm={8} md={9}>
    <Typography variant='body2' color={appThemeColor}>
        {AssignmentDetailsAry.assign_contact_person
            ? `${AssignmentDetailsAry.assign_contact_person} / ${AssignmentDetailsAry.assign_requester_details.requester_name}`
            : AssignmentDetailsAry.assign_requester_details.requester_name}
    </Typography>
</Grid>
</Grid>
                                        <Divider sx={{ borderRadius: '10px' }} />
                    <Grid container > <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Mode</ Typography> </Grid>  <Grid xs={7} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_service_mode}</ Typography></Grid> </Grid>
                    <Divider sx={{ borderRadius: '10px' }} />
                    {/* <Grid container > <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Reporting Time</ Typography> </Grid>  <Grid xs={7} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{dayjs(AssignmentDetailsAry.assign_reporting_time).format('hh:mm A [on] MM/DD/YYYY')}</ Typography></Grid> </Grid>
                    <Divider sx={{ borderRadius: '10px' }} /> */}
                    <Grid container > <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Time Zone</ Typography> </Grid>  <Grid xs={7} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_timezone_daylight}</ Typography></Grid> </Grid>
                    <Divider sx={{ borderRadius: '10px' }} />
                    <Grid container > <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Requested Duration</ Typography> </Grid>  <Grid xs={7} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_duration}</ Typography></Grid> </Grid>
                    <Divider sx={{ borderRadius: '10px' }} />
                    {AssignmentDetailsAry.service_type === "InPerson Interpretation" && <Box>
                        <Grid container > <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Location</ Typography> </Grid>  <Grid xs={7} sm={8} md={9}> <Box sx={{ wordWrap: 'break-word', width: '100%' }}><Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_location}</ Typography></Box></Grid> </Grid>
                        <Divider sx={{ borderRadius: '10px' }} />
                        <Grid container > <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Venue Remarks</ Typography> </Grid>  <Grid xs={7} sm={8} md={9}> <Box sx={{ wordWrap: 'break-word', width: '100%' }}><Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_add_row_by_service_type}</ Typography></Box></Grid> </Grid>
                        <Divider sx={{ borderRadius: '10px' }} />
                    </Box>}
                    {AssignmentDetailsAry.service_type === "Over the Phone" && <Box><Grid container > <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Dial Phone</ Typography> </Grid>  <Grid xs={7} sm={8} md={9}> <Box sx={{ wordWrap: 'break-word', width: '100%' }}> <Link href={'tel:' + AssignmentDetailsAry.assign_add_row_by_service_type} underline="hover" variant="body2" color={appThemeColor}> {AssignmentDetailsAry.assign_add_row_by_service_type} </Link></Box></Grid> </Grid>  <Divider sx={{ borderRadius: '10px' }} /></Box>}
                    {AssignmentDetailsAry.service_type === "Video Remote" && <Box><Grid container > <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Video Link</ Typography> </Grid>  <Grid xs={7} sm={8} md={9}> <Box sx={{ wordWrap: 'break-word', width: '100%' }}><Link variant='body2' target='_blank' underline="hover" href={AssignmentDetailsAry.assign_add_row_by_service_type} color={appThemeColor}>{AssignmentDetailsAry.assign_add_row_by_service_type}</ Link></Box></Grid> </Grid><Divider sx={{ borderRadius: '10px' }} /></Box>}
                    <Box><Grid container > <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Special Instructions</ Typography> </Grid>  <Grid xs={7} sm={8} md={9}> <Box sx={{ wordWrap: 'break-word', width: '100%' }}><Link variant='body2' target='_blank' underline="hover" href={AssignmentDetailsAry.assign_instruction} color={appThemeColor}>{AssignmentDetailsAry.assign_instruction}</ Link></Box></Grid> </Grid><Divider sx={{ borderRadius: '10px' }} /></Box>
                    <Grid container > <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Consumer of Service</ Typography> </Grid>  <Grid xs={7} sm={8} md={9}> <Box sx={{ wordWrap: 'break-word', width: '100%' }}><Typography variant='body2' color={appThemeColor}>{AssignmentDetailsAry.assign_consumer_service_name}</ Typography></Box></Grid> </Grid>
                    <Divider sx={{ borderRadius: '10px' }} />
                </Box>



            </Box>

            {AssignmentCustomerPromtAfterAcceptAry.length !== 0 &&
                <Box sx={{ mt: 1, ml: 1 }}>
                    <Typography variant="h6" fontWeight="bold" color={appThemeColor} > Customer Prompt </Typography>
                    {AssignmentCustomerPromtAfterAcceptConsumerServName !== '' && <Box sx={{ wordWrap: 'break-word', width: '100%' }}>
                        <Grid container > 
                            <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'>Consumer of Service</ Typography> </Grid> 
                            <Grid xs={7} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{AssignmentCustomerPromtAfterAcceptConsumerServName}</ Typography></Grid> 
                        </Grid>
                    <Divider sx={{ borderRadius: '10px' }} />
                    </Box>}
                    {AssignmentCustomerPromtAfterAcceptAry.map((customer_promt, index) => {
                        var customer_promt_obj_key = Object.keys(customer_promt);

                        return (<Box key={index} >
                            <Grid container > 
                                <Grid xs={5} sm={4} md={3}><Typography variant='body2' fontWeight='bold'  >{customer_promt_obj_key}</ Typography> </Grid>  
                                <Grid xs={7} sm={8} md={9}> <Typography variant='body2' color={appThemeColor}>{customer_promt[customer_promt_obj_key]}</ Typography></Grid> 
                            </Grid>
                            <Divider sx={{ borderRadius: '10px' }} />
                        </Box>);
                    })}
                </Box>
            }
            {/* Sched-1436-starts disabling it */}
            {/* {AssignmentDetailsAry.service_type === "InPerson Interpretation" && <Box>
                <Box sx={{ display: 'flex', justifyContent: 'end', mt: 1 }}>
                    <LoadingButton size='small' sx={{ color: appThemeColor, textTransform: 'none', textDecoration: 'underline' }} onClick={() => AssignmentDownloadVoucherHtml(assign_id)} startIcon={<DownloadIcon fontSize='small' sx={{ mr: -0.5 }} />} loadingPosition='start' loading={DownloadVoucherLoadingButton}>
                        Download Blank Voucher
                    </LoadingButton>
                </Box>
            </Box>} */}
             {/* Sched-1436-ends disabling it */}
            <Box sx={{ mt: 3 }}>
                <Grid container justifyContent="center" spacing={{ xs: 2, sm: 3, md: 5 }} >
                    {StartButtonStatus === "Start" && AssignmentDetailsAry.service_type === "InPerson Interpretation" && <Grid xs={4} sm={3} md={2} >
                        <LoadingButton variant="contained" sx={{ height: '50px', width: '100%', backgroundColor: '#89B601', color: '#fff', textTransform: 'none', fontWeight: 'bold', '&:hover': { backgroundColor: '#5f7f00' } }} loadingPosition="center" onClick={() => AssignmentStartAction('Started')} loading={StartButtonLoading} disabled={(startButtoncancelDisable || startArrivedDisabled)} ><CheckCircleOutlineOutlinedIcon sx={{ position: 'absolute', top: '2px' }} /><Typography variant='body2' sx={{ position: 'absolute', bottom: '2px' }}>Start Travel</Typography></LoadingButton>
                    </Grid>}
                    {StartButtonStatus === "Arrived" && AssignmentDetailsAry.service_type === "InPerson Interpretation" && <Grid xs={4} sm={3} md={2} >
                        <LoadingButton variant="contained" sx={{ height: '50px', width: '100%', backgroundColor: '#89B601', color: '#fff', textTransform: 'none', fontWeight: 'bold', '&:hover': { backgroundColor: '#5f7f00' } }} loadingPosition="center" onClick={() => AssignmentStartAction('Arrived')} loading={ArrivedButtonLoading} disabled={(startButtoncancelDisable || startArrivedDisabled)} ><CheckCircleOutlineOutlinedIcon sx={{ position: 'absolute', top: '2px' }} /><Typography variant='body2' sx={{ position: 'absolute', bottom: '2px' }}>Arrived</Typography></LoadingButton>
                    </Grid>}
                    <Grid xs={(AssignmentDetailsAry.service_type === "InPerson Interpretation") ? 4 : 6} sm={3} md={2} > <LoadingButton variant="contained" sx={{ height: '50px', width: '100%', backgroundColor: '#89B601', color: '#fff', textTransform: 'none', fontWeight: 'bold', '&:hover': { backgroundColor: '#5f7f00' } }} loadingPosition="center" onClick={() => AssignmentStartAction('Check In')} loading={GetStartButtonLoading} disabled={startButtoncancelDisable} ><CheckCircleOutlineOutlinedIcon sx={{ position: 'absolute', top: '2px' }} /><Typography variant='body2' noWrap sx={{ position: 'absolute', bottom: '2px' }}>Get Started</Typography></LoadingButton></Grid>
                    <Grid xs={(AssignmentDetailsAry.service_type === "InPerson Interpretation") ? 4 : 6} sm={3} md={2} > <LoadingButton variant="contained" sx={{ height: '50px', width: '100%', backgroundColor: '#f44336', color: '#fff', textTransform: 'none', fontWeight: 'bold', '&:hover': { backgroundColor: '#aa2e25' } }} loadingPosition="center" onClick={() => AssignmentStartAction('Cancelled')} loading={CancelButtonLoading} disabled={startButtoncancelDisable}><CancelOutlinedIcon sx={{ position: 'absolute', top: '2px' }} /><Typography variant='body2' sx={{ position: 'absolute', bottom: '2px' }}>Withdraw</Typography></LoadingButton></Grid>
                </Grid>

            </Box>

        </Box >
    )
}

